// Switch.js
import React from "react";
import "./Switch.css";

export default function Switch({
  checked,
  onChange,
  disabled = false,
  id,
  name,
  size = "md",
  label,
  labelLeft,
  className = "",
}) {
  const switchId = id || `switch-${Math.random().toString(36).slice(2, 8)}`;

  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onChange?.(!checked);
    }
    if (e.key === "ArrowLeft") {
      e.preventDefault();
      onChange?.(false);
    }
    if (e.key === "ArrowRight") {
      e.preventDefault();
      onChange?.(true);
    }
  };

  return (
    <div
      className={`lc-switch ${className}`}
      data-size={size}
      data-checked={checked ? "true" : "false"}
      data-disabled={disabled ? "true" : "false"}
    >
      {labelLeft ? (
        <label className="lc-switch__text lc-switch__text--left" htmlFor={switchId}>
          {labelLeft}
        </label>
      ) : null}

      <div
        className="lc-switch__control"
        role="switch"
        aria-checked={checked}
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={handleKeyDown}
        onClick={() => !disabled && onChange?.(!checked)}
      >
        {/* Native input: for forms + screen readers */}
        <input
          id={switchId}
          name={name}
          type="checkbox"
          className="lc-switch__input"
          checked={!!checked}
          disabled={disabled}
          onChange={(e) => onChange?.(e.target.checked)}
          aria-hidden="true"
          tabIndex={-1}
        />

        <span className="lc-switch__track" />
        <span className="lc-switch__thumb" />
      </div>

      {label ? (
        <label className="lc-switch__text" htmlFor={switchId}>
          {label}
        </label>
      ) : null}
    </div>
  );
}